import { GridFilterTypes } from "../../../grid/AgGridManager";

export const equipmentAdministrator = {
  name: "equipmentAdministrator",
  grid: {
    displayed: false,
    order: 36,
    filter: GridFilterTypes.SET,
  },
  data: {
    active: false,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Test equipment administrator",
    displayed: false,
    disabled: true,
  },
};
